import { HeroSection } from "@/components/hero-section"
import { GapSection } from "@/components/gap-section"
import { PartnersSection } from "@/components/partners-section"
import { AboutSection } from "@/components/about-section"
import { WorkSection } from "@/components/work-section"
import { CredibilitySection } from "@/components/credibility-section"
import { ProofSection } from "@/components/proof-section"
import { ReassureSection } from "@/components/reassure-section"
import { DifferentiateSection } from "@/components/differentiate-section"
import { TapeOutsSection } from "@/components/tape-outs-section"
import { CloseSection } from "@/components/close-section"
import { ColophonSection } from "@/components/colophon-section"
import { SideNav } from "@/components/side-nav"
import { TopNav } from "@/components/top-nav"

export default function HomePage() {
  return (
    <main className="relative min-h-screen">
      <TopNav />
      <SideNav />
      <div className="grid-bg fixed inset-0 opacity-30" aria-hidden="true" />

      <div className="relative z-10">
        <HeroSection />
        <PartnersSection />
        <GapSection />
        <AboutSection />
        <WorkSection />
        <CredibilitySection />
        <ProofSection />
        <ReassureSection />
        <DifferentiateSection />
        <TapeOutsSection />
        <CloseSection />
        <ColophonSection />
      </div>
    </main>
  )
}
